<template>
  <div>
    <slotModal
      :id-modal="'modalExample'"
      :modal-title="'example Modal'"
      :footer="false"
      v-model="modal"
      @close="close"
    >
      <template v-slot:modal-content>
        <div class="p-a-16" style="background-color: #f2f5f7">
          <p class="f-Overpass f-w-400 f-14 m-0">
            E-Pay Londi dapat anda gunakan di outlet-outlet berikut
          </p>
        </div>
      </template>
    </slotModal>
  </div>
</template>
<script>
import slotModal from "@/components/slots/slotModal.vue";

export default {
  name: "modalExample",
  components: {
    slotModal,
  },
  data() {
    return {
      modal: false,
    };
  },

  methods: {
    open() {
      this.modal = true;
    },
    close() {
      this.modal = false;
    },
  },
};
</script>
